import React, { useEffect, useState } from "react";
import { Content, Row, Col, Box, Button, Inputs } from "adminlte-2-react";
import queryString from "query-string";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import SelectInput from "../utils/SelectInput";
import "react-phone-input-2/lib/style.css";
import { HexColorPicker } from "react-colorful";
import Loader from "../utils/Loader";
import ReferenciaObligatorios from "../utils/etiquetaObligatorio/ReferenciaObligatorios";
import Etiqueta from "../utils/etiquetaObligatorio/Etiqueta";
import { logger } from "../utils/utils";
import config from "../config";

const { Text } = Inputs;

const estadoOptions = () => [
  { value: "ACTIVO", label: "ACTIVO" },
  { value: "INACTIVO", label: "INACTIVO" },
];

function AddProfesional({ history, match }) {
  const dispatch = useDispatch();

  const modelAddProfesional = useSelector((state) => state.cargarProfesional);

  const [token] = useState(() => localStorage.getItem("token"));
  const [nombre, setNombre] = useState(null);
  const [profesion, setProfesion] = useState(null);
  const [estado, setEstado] = useState("ACTIVO");
  const [localId, setLocalId] = useState(match.params.localId);
  const [color, setColor] = useState("#aabbcc");
  const [mostrarColorPicker, setMostrarColorPicker] = useState(false);

  useEffect(() => {
    const data = modelAddProfesional?.data?.data;
    const error = modelAddProfesional?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duck.actions.clear());
    }
    if (data) {
      // history.push(`/profesionales/${match.params.localId}`);
      const idProfesionalCreado = data?.data?._id;
      dispatch(controller.duck.actions.clear());
      navigateToSubirImagenes(idProfesionalCreado);
    }
  }, [modelAddProfesional]);

  const navigateToSubirImagenes = (profesionalId) => {
    logger.debug("navigateToSubirImagenes");

    const baseUrl = config.api.baseUrl;
    const key = config.api.key;

    const concepto = "profesional";
    const conceptoId = profesionalId;

    logger.debug({ concepto });
    logger.debug({ config });
    logger.debug({
      imgRestrictionsByConcepto: config.imgRestrictionsByConcepto[concepto],
    });

    const uploadConfigVariant = "upload";
    const cropConfigVariant = "crop";

    const uploadUrl = `${baseUrl}/agregarImagen/${concepto}/${conceptoId}/?userToken=${token}&esTemporal=true&configVariant=${uploadConfigVariant}`;
    const uploadHeaders = {
      "x-access-token": key,
    };

    const cropUploadUrl = `${baseUrl}/agregarImagen/${concepto}/${conceptoId}/?userToken=${token}&esTemporal=false&configVariant=${cropConfigVariant}`;
    const cropConfig =
      config.imgRestrictionsByConcepto[concepto][cropConfigVariant];

    const nextStepUrl = `/cortarImagenes`;
    const lastStepUrl = `/profesionales/${match.params.localId}`;
    const cancelUrl = lastStepUrl;

    const params = queryString.stringify({
      conceptoId,
      concepto,
      uploadUrl,
      rawUploadHeaders: JSON.stringify(uploadHeaders),
      nextStepUrl,
      pageTitle: "Subida de imágenes",
      pageSubtitle: "Paso 1 : Subida",
      nextButtonText: "Siguiente",
      cropConfig: JSON.stringify(cropConfig),
      cropUploadUrl,
      saveInConceptUrl: `${baseUrl}/agregarImagenAProfesional`,
      lastStepUrl,
      cancelUrl,
      ...config.imgRestrictionsByConcepto[concepto][uploadConfigVariant],
    });

    logger.debug("paramsBeforeNavigate");
    logger.debug(params);

    history.push(`/subirImagenes?${params}`);
  };  

  function submit() {
    if (!nombre || !estado || !localId) {
      alert("Por favor complete todos los campos");
      return;
    }
    let data = {
      nombre,
      estado,
      localId,
      profesion,
      color: mostrarColorPicker ? color : null,
    };
    dispatch(controller.cargarProfesionalThunk(data));
  }

  return (
    <Content
      title="Nuevo profesional"
      browserTitle="Nuevo profesional"
      show={false}
    >
      <Row>
        <Col md="4" mdOffset="4">
          <Box
            title="Nuevo profesional"
            footer={
              <>
                <Button
                  text="Cancelar"
                  disabled={false}
                  onClick={() => {
                    history.push(`/profesionales/${match.params.localId}`);
                  }}
                />

                <Button
                  type="primary"
                  text={
                    <Loader
                      loaderColor="#ffffff"
                      isLoading={modelAddProfesional.loading}
                    >
                      Ir a subir imagen
                    </Loader>
                  }
                  pullRight={true}
                  disabled={modelAddProfesional.loading}
                  onClick={() => submit()}
                />
              </>
            }
          >
            <ReferenciaObligatorios />

            <Text
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Nombre" obligatorio={true} />}
              value={nombre}
              onChange={(evt) => setNombre(evt.target.value)}
            />
            <Text
              labelPosition="above"
              size="sm"
              label="Profesión"
              value={profesion}
              onChange={(evt) => setProfesion(evt.target.value)}
            />
            <SelectInput
              value={estado}
              setValue={setEstado}
              label="Estado"
              options={estadoOptions()}
            />

            <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  onChange={() => setMostrarColorPicker(!mostrarColorPicker)}
                  checked={mostrarColorPicker}
                />{" "}
                Definir color para calendario
              </label>
            </div>

            {mostrarColorPicker && (
              <HexColorPicker color={color} onChange={setColor} />
            )}
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default AddProfesional;
